import { IonIcon } from '@ionic/react';
import React from 'react';

import { useInView } from '@/hooks';
import { TestimonialItem } from '@/utils/types';
import { star } from 'ionicons/icons';

import './TestimonialCard.css';

interface TestimonialCardProps {
  testimonial: TestimonialItem;
  index: number;
}

const TestimonialCard: React.FC<TestimonialCardProps> = ({ testimonial }) => {
  const [ref, inView] = useInView({
    triggerOnce: true
  });

  const renderStars = () => {
    return Array.from({ length: 5 }, (_, starIndex) => (
      <IonIcon key={starIndex} icon={star} className="testimonial-card__star" />
    ));
  };

  return (
    <div
      className={`testimonial-card ${inView ? 'testimonial-card--in-view' : ''}`}
    >
      <div className="testimonial-card__image-container" ref={ref}>
        <img
          src={testimonial.image}
          alt={`${testimonial.clinic} testimonial`}
          className="testimonial-card__image"
        />
        <div className="testimonial-card__stars-container">{renderStars()}</div>
      </div>
      <div className="testimonial-card__content">{testimonial.content}</div>
      <div className="testimonial-card__author">
        <div className="testimonial-card__author-name">
          {testimonial.author}
        </div>
        <div className="testimonial-card__author-clinic">
          {testimonial.clinic}
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;
